import React from 'react';

import { localStorageUtils } from '../../utils/local-storage-utils';

type BooleanSettingKey =
  | 'designToolTooltipInMenu'
  | 'designToolTooltipInMenuLight'
  | 'snappingDialogTooltip'
  | 'snappingDialogTooltipLight'
  | 'designToolAllHeights'
  | 'snappingDialogAllHeights';

/**
 * A setting that is on or off, remembered for the user in the browser.
 */
export const useStoredSetting = (key: BooleanSettingKey) => {
  const [value, setValue] = React.useState(
    () => localStorageUtils.getUserItemOrDefault(key, 'false') === 'true',
  );

  const setStoredValue = (newValue: boolean) => {
    setValue(newValue);
    localStorageUtils.setUserItem(key, newValue.toString());
  };

  return [value, setStoredValue] as const;
};
